module.exports = "/lucky-balls/img/bonus_yellow/header_betole.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/header_betole.png
// module id = 964
// module chunks = 0